"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ClearIcon = _interopRequireDefault(require("../icons/forms/ClearIcon"));

var _VisibilityAnimation = _interopRequireDefault(require("../VisibilityAnimation"));

var _OnClickOutside = _interopRequireDefault(require("../OnClickOutside"));

var _FocusManager = _interopRequireDefault(require("../FocusManager"));

var _renderToLayer = _interopRequireDefault(require("../hoc/render-to-layer"));

var _zIndexStack = _interopRequireDefault(require("../hoc/z-index-stack"));

var _keys = require("../constants/keys");

var _zIndexes = require("../constants/z-indexes");

var _theme = require("../theme");

var _compose = _interopRequireDefault(require("../utils/compose"));

var _mixins = require("../utils/mixins");

var _focusSource = require("../utils/focus-source");

var _createGetMemoizedRef = _interopRequireDefault(require("../utils/createGetMemoizedRef"));

function _createSuper(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

(0, _focusSource.subscribeFocusEvents)();

var styles = function styles(theme) {
  return {
    backdrop: {
      extend: [_mixins.isolateMixin, _mixins.middleMixin],
      fontFamily: theme.fontFamily,
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      paddingTop: 20,
      paddingBottom: 20,
      textAlign: 'center',
      overflowY: 'auto',
      overflowX: 'hidden',
      marginTop: -10,
      opacity: 0,
      transitionDuration: theme.popup.animationDuration,
      transitionProperty: 'margin-top, opacity'
    },
    'backdrop-black': {
      backgroundColor: theme.popup.colors.backdrop.default
    },
    'backdrop-blue': {
      backgroundColor: theme.popup.colors.backdrop.blue
    },
    isVisible: {
      marginTop: 0,
      opacity: 1
    },
    popup: (0, _extends2.default)({
      position: 'relative',
      display: 'inline-block',
      boxSizing: 'border-box',
      borderRadius: theme.popup.borderRadius,
      boxShadow: theme.popup.boxShadow,
      padding: [20, 25, 25],
      color: theme.popup.colors.text,
      minWidth: 300,
      maxWidth: 'calc(100% - 20px)',
      marginLeft: 10,
      marginRight: 10,
      backgroundColor: theme.popup.colors.background,
      fontSize: theme.popup.text.fontSize,
      lineHeight: "".concat(theme.popup.text.lineHeight, "px"),
      textAlign: 'left',
      outline: 'none'
    }, (0, _mixins.ifDesktop)({
      minWidth: 350,
      maxWidth: 'auto'
    })),
    title: {
      marginBottom: 20,
      paddingRight: 25,
      fontSize: theme.popup.title.fontSize,
      lineHeight: "".concat(theme.popup.title.lineHeight, "px"),
      fontWeight: 500
    },
    close: (0, _extends2.default)({
      position: 'absolute',
      top: 25,
      right: 25,
      border: 0,
      margin: 0,
      padding: 0,
      width: 15,
      height: 15,
      background: 'transparent',
      outline: 0,
      color: theme.popup.colors.close.default,
      cursor: 'pointer',
      '&:hover': {
        color: theme.popup.colors.close.hover
      }
    }, (0, _mixins.focusSourceMixin)('other', '&:focus', {
      color: theme.popup.colors.close.hover
    }), {}, (0, _mixins.ifMobile)({
      top: 15,
      right: 15
    })),
    buttons: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: 30,
      '& > *': {
        flexGrow: 1,
        width: '50%'
      },
      '& > * + *': (0, _extends2.default)({
        marginLeft: 10
      }, (0, _mixins.ifDesktop)({
        marginLeft: 20
      }))
    }
  };
};

var _ref = /*#__PURE__*/_react.default.createElement(_ClearIcon.default, {
  size: 15,
  color: "currentColor"
});

var Popup = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(Popup, _PureComponent);

  var _super = _createSuper(Popup);

  function Popup() {
    var _this;

    (0, _classCallCheck2.default)(this, Popup);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.onWillVisible = function () {
      window.addEventListener('keydown', _this.onKeyDown);
    };

    _this.onWillInvisible = function () {
      window.removeEventListener('keydown', _this.onKeyDown);
    };

    _this.onKeyDown = function (event) {
      var _assertThisInitialize = (0, _assertThisInitialized2.default)(_this),
          closeOnEsc = _assertThisInitialize.closeOnEsc,
          onRequestClose = _assertThisInitialize.onRequestClose;

      if (closeOnEsc && event.keyCode === _keys.ESCAPE) onRequestClose();
    };

    _this.getMemoizedRef = (0, _createGetMemoizedRef.default)();

    _this.renderContent = function (componentRef) {
      var _this$props = _this.props,
          children = _this$props.children,
          className = _this$props.className,
          style = _this$props.style,
          title = _this$props.title,
          titleStyle = _this$props.titleStyle,
          titleClassName = _this$props.titleClassName,
          buttonsContainerStyle = _this$props.buttonsContainerStyle,
          buttonsContainerClassName = _this$props.buttonsContainerClassName,
          classes = _this$props.classes,
          showClose = _this$props.showClose,
          okButton = _this$props.okButton,
          tabIndex = _this$props.tabIndex,
          cancelButton = _this$props.cancelButton,
          onRequestClose = _this$props.onRequestClose,
          theme = _this$props.theme;
      return _react.default.createElement(_FocusManager.default, {
        tabIndex: tabIndex
      }, function (focusRef) {
        return _react.default.createElement("div", {
          style: style,
          className: (0, _classnames.default)(classes.popup, className),
          ref: _this.getMemoizedRef(focusRef, componentRef)
        }, showClose && _react.default.createElement("button", {
          className: classes.close,
          onClick: onRequestClose,
          "aria-label": theme.i18n.closePopup
        }, _ref), title && _react.default.createElement("header", {
          style: titleStyle,
          className: (0, _classnames.default)(classes.title, titleClassName)
        }, title), children, (okButton || cancelButton) && _react.default.createElement("footer", {
          style: buttonsContainerStyle,
          className: (0, _classnames.default)(classes.buttons, buttonsContainerClassName)
        }, okButton, cancelButton));
      });
    };

    return _this;
  }

  (0, _createClass2.default)(Popup, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.onWillInvisible();
    }
  }, {
    key: "renderPopup",
    value: function renderPopup() {
      var _this2 = this;

      var _this$props2 = this.props,
          closeOnClickOutside = _this$props2.closeOnClickOutside,
          onRequestClose = _this$props2.onRequestClose;
      if (closeOnClickOutside) return _react.default.createElement(_OnClickOutside.default, {
        handler: onRequestClose
      }, function (componentRef) {
        return _this2.renderContent(componentRef);
      });
      return this.renderContent();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props3 = this.props,
          isOpened = _this$props3.isOpened,
          backdropClassName = _this$props3.backdropClassName,
          backdropStyle = _this$props3.backdropStyle,
          backdropColor = _this$props3.backdropColor,
          theme = _this$props3.theme,
          classes = _this$props3.classes,
          onOpen = _this$props3.onOpen,
          onClose = _this$props3.onClose;
      return _react.default.createElement(_VisibilityAnimation.default, {
        isVisible: isOpened,
        animationDuration: theme.popup.animationDuration,
        onWillVisible: this.onWillVisible,
        onVisible: onOpen,
        onWillInvisible: this.onWillInvisible,
        onInvisible: onClose
      }, function (_ref2) {
        var isVisible = _ref2.isVisible;
        return _react.default.createElement("div", {
          ref: function ref(el) {
            _this3.backdrop = el;
          },
          style: backdropStyle,
          className: (0, _classnames.default)(classes.backdrop, classes["backdrop-".concat(backdropColor)], backdropClassName, isVisible && classes.isVisible)
        }, _this3.renderPopup());
      });
    }
  }]);
  return Popup;
}(_react.PureComponent);

Popup.defaultProps = {
  isOpened: false,
  showClose: true,
  closeOnEsc: true,
  closeOnClickOutside: true,
  backdropColor: 'black',
  tabIndex: 0,
  onOpen: function onOpen() {},
  onRequestClose: function onRequestClose() {},
  onClose: function onClose() {}
};
Popup.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Css-класс
   */
  className: _propTypes.default.string,

  /**
   * Inline-стили
   */
  style: _propTypes.default.object,

  /**
   * Css-класс для фонового слоя
   */
  backdropClassName: _propTypes.default.string,

  /**
   * Inline-стили для фонового слоя
   */
  backdropStyle: _propTypes.default.object,

  /**
   * Цвет фонового слоя
   */
  backdropColor: _propTypes.default.oneOf(['black', 'blue']),

  /**
   * Контент для попапа
   */
  children: _propTypes.default.node,

  /**
   * Заголовок
   */
  title: _propTypes.default.node,

  /**
   * Css-класс для заголовка
   */
  titleClassName: _propTypes.default.string,

  /**
   * Inline-стили для заголовка
   */
  titleStyle: _propTypes.default.object,

  /**
   * Css-класс блока с кнопками
   */
  buttonsContainerClassName: _propTypes.default.string,

  /**
   * Inline-стили блока с кнопками
   */
  buttonsContainerStyle: _propTypes.default.object,

  /**
   * Контролирует видимость попапа
   */
  isOpened: _propTypes.default.bool,

  /**
   * Порядок фокусировки элемента
   */
  tabIndex: _propTypes.default.number,

  /**
   * Кнопка успешного действия (если она одна, то будет расятнута на все ширину)
   */
  okButton: _propTypes.default.node,

  /**
   * Кнопка отмены
   */
  cancelButton: _propTypes.default.node,

  /**
   * Кнопка закрытия попапа
   */
  showClose: _propTypes.default.bool,

  /**
   * Закрытие попапа кнопкой esc
   */
  closeOnEsc: _propTypes.default.bool,

  /**
   * Закрытие попапа по клику вне него
   */
  closeOnClickOutside: _propTypes.default.bool,

  /**
   * Коллбек вызывающийся после открытия попапа
   */
  onOpen: _propTypes.default.func,

  /**
   * Коллбек вызывающийся при нажатии на крестик (автоматически проставляется, если используется `@providePopup`)
   */
  onRequestClose: _propTypes.default.func,

  /**
   * Коллбек вызывающийся после закрытия попапа
   */
  onClose: _propTypes.default.func
} : {};

var _default = (0, _compose.default)((0, _zIndexStack.default)(_zIndexes.POPUP_ZINDEX), _renderToLayer.default, (0, _theme.withStyles)(styles, {
  name: 'Popup'
}))(Popup);

exports.default = _default;